import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home"
import About from "../views/About"
import Product from "../views/Product.vue"
import test from "../views/test.vue"
Vue.use(VueRouter);//使用一个vue插件

const router =new VueRouter({
  //配置
  routes:[
    //路由规则
    {path:'/',component:Home},
    {path:'/about',component:About},
    {path:'/product',component:Product},
    {path:'/test',component:test},
  ],
  mode:"history",
});

export default router;